// @flow

// core
import React, { type Node } from 'react';

// libs
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { type ISkeletonProps, LoaderSkeleton } from './LoaderSkeleton';

export const Study = ({ children, isLoading }: ISkeletonProps): Node =>
	isLoading ? (
		<Box sx={SX.pageWrapper}>
			<Box sx={SX.leftNavContainer}>
				<LoaderSkeleton sx={{ ...SX.studyItem, marginTop: '56px' }} />
				<LoaderSkeleton sx={SX.studyItem} />
				<LoaderSkeleton sx={SX.studyItem} />
			</Box>

			<Paper sx={SX.paperStyles}>
				<Box sx={SX.mainContent}>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							marginBottom: '20px',
						}}
					>
						<LoaderSkeleton sx={SX.breadcrumbItem} />
						<LoaderSkeleton sx={SX.breadcrumbItem} />
					</Box>

					<Box sx={SX.studySkeletonWrapper}>
						<LoaderSkeleton
							sx={{
								...SX.studySkeleton,
								borderLeft: '5px solid #3CA3F5',
								height: '330px',
								borderRadius: '10px 10px 0 0',
							}}
						/>
						<LoaderSkeleton sx={{ ...SX.studySkeleton, borderLeft: '5px solid #7D7AFF' }} />
						<LoaderSkeleton sx={{ ...SX.studySkeleton, borderLeft: '5px solid #42F59F' }} />
						<LoaderSkeleton sx={{ ...SX.studySkeleton, borderLeft: '5px solid #EB459E' }} />
						<LoaderSkeleton
							sx={{ ...SX.studySkeleton, borderLeft: '5px solid #F282BE', borderRadius: '0 0 10px 10px' }}
						/>
					</Box>
				</Box>
			</Paper>
		</Box>
	) : (
		children
	);

const SX = {
	pageWrapper: {
		display: 'flex',
		height: '100%',
		width: '100%',
	},

	leftNavContainer: {
		width: '80px',
		backgroundColor: '#393939',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '20px 6px 20px 0px',
		borderRadius: '10px 0px 0px 10px',
		marginRight: '-6px',
		paddingRight: '6px',
	},

	studyItem: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		width: '80px',
		height: '81px',
		cursor: 'pointer',
		border: '1px solid #272727',
		borderWidth: '1px 0px 1px 0px',
	},

	mainContent: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		padding: '10px',
		gap: '10px',
		overflow: 'auto',
	},

	breadcrumb: {
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
	},

	breadcrumbItem: {
		width: '200px',
		height: '20px',
		borderRadius: '4px',
	},

	studySkeletonWrapper: {
		display: 'grid',
		rowGap: '5px',
	},

	studySkeleton: {
		width: '100%',
		height: '70PX',
		borderRadius: '0px',
	},
	paperStyles: {
		backgroundColor: '#393939',
		padding: '20px 40px 20px 40px',
		boxShadow: '-4px 0px 10px 0px #00000040',
		width: '100%',
		borderRadius: '10px',
		overflowY: 'scroll',
	},
	containerStyles: {
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		gap: '5px',
	},
};
